import { create } from 'zustand'
import type { AggregationResults } from '~/services/graphql/generated'

interface AggregationStore {
    aggregationResults: AggregationResults | null
    setAggregationResults: (results: AggregationResults | null) => void

    activeFilterName: string | null
    setActiveFilterName: (filterName: string | null) => void

    isFilterActive: (filterName: string) => boolean

    isLoading: boolean
    setIsLoading: (isLoading: boolean) => void
}

// Stores aggregation results and other state related to the filters that are always
// (at least partly) expanded when the filter bar is open
export const useAggregationStore = create<AggregationStore>((set, get) => ({
    activeFilterName: null,
    setActiveFilterName: (filterName: string | null) =>
        set({ activeFilterName: filterName }),
    isFilterActive: (filterName: string) =>
        filterName === get().activeFilterName,

    isLoading: false,
    setIsLoading: (isLoading: boolean) => set({ isLoading }),

    aggregationResults: null,
    setAggregationResults: (results: AggregationResults | null) =>
        set({ aggregationResults: results }),
}))
